import { createSelector } from "reselect"

const selectPage = state => state.page

export const selectActualPage = createSelector([selectPage], page => page.actualPage.page)

export const selectActualWidgets = createSelector([selectPage], page => page.actualPage.widgets)

const getWidgetIdFromProps = (state, props) => props?.widgetInfo?._id?.$oid

//WIDGET DATA
export const selectActualWidgetsData = createSelector(
  [selectPage],
  page => page.actualPage.widgetsData
)

export const makeGetWidgetDataWithId = () => {
  return createSelector(
    [getWidgetIdFromProps, selectActualWidgetsData],
    (widgetId, widgetsData) => {
      if (!widgetId) return { columns: [], data: [] }
      else if (widgetsData && widgetsData.hasOwnProperty(widgetId)) {
        return widgetsData[widgetId]
      }
      return { columns: [], data: [] }
    }
  )
}

// NEED TO CHECK? MAYBE USELESS
export const makeGetWidgetDataWithIdInWidgetSettings = () => {
  return createSelector([selectActualWidgetsData], widgetsData => {
    if (widgetsData && widgetsData.hasOwnProperty("widgetBeingEdited")) {
      return widgetsData["widgetBeingEdited"]
    }
    return { columns: [], data: [] }
  })
}

//WIDGET FILTER DATA
export const selectWidgetFilterData = createSelector(
  [selectPage],
  page => page.actualPage.widgetFilterData
)

export const makeGetWidgetFilterDataWithId = () => {
  return createSelector(
    [getWidgetIdFromProps, selectWidgetFilterData],
    (widgetId, widgetsFilterData) => {
      if (!widgetId) return {}
      else if (widgetsFilterData && widgetsFilterData.hasOwnProperty(widgetId)) {
        return widgetsFilterData[widgetId]
      }
      return {}
    }
  )
}

export const makeGetWidgetFilterDataWithIdInWidgetSettings = () => {
  return createSelector([selectWidgetFilterData], widgetsFilterData => {
    if (widgetsFilterData && widgetsFilterData.hasOwnProperty("widgetBeingEdited")) {
      return widgetsFilterData["widgetBeingEdited"]
    }
    return {}
  })
}

// Widget Request Status
export const selectWidgetRequestStatus = createSelector(
  [selectPage],
  page => page.actualPage.widgetsRequestStatus
)

export const makeGetWidgetRequestStatusWithId = () => {
  return createSelector(
    [getWidgetIdFromProps, selectWidgetRequestStatus],
    (widgetId, widgetsRequestStatus) => {
      if (!widgetId) return "NOT_SET"
      else if (widgetsRequestStatus && widgetsRequestStatus.hasOwnProperty(widgetId)) {
        return widgetsRequestStatus[widgetId]
      }
      return "NOT_SET"
    }
  )
}

export const selectActualPagePermissions = createSelector(
  [selectPage],
  page => page.actualPage.pagePermissions
)

export const selectActualPageIsPublic = createSelector(
  [selectPage],
  page => page.actualPage.page?.isPublic || false
)

export const selectValueFilterSelected = createSelector(
  [selectPage],
  page => page.actualPage.valueFilterSelected
)

export const selectComparisonValues = createSelector(
  [selectPage],
  page => page?.actualPage?.comparisonValues
)

export const selectwidgetDictionaryTempIdNewId = createSelector(
  [selectPage],
  page => page.actualPage.dictionary
)

// uploadStatus
export const selectWidgetImageUploadStatus = createSelector(
  [selectPage],
  page => page?.actualPage?.widgetImageData?.widgetBeingEdited?.uploadStatus
)

export const selectLastWidgetSaved = createSelector(
  [selectPage],
  page => page?.actualPage?.lastWidgetSave
)

//PAGE STATUS
export const selectSavingStatus = createSelector(
  [selectPage],
  page => page?.actualPage?.pageInformations?.savingStatus
)

/**
 * Réglage de page « filtres dépendants » (écart E4).
 *
 * ⚠️ Lu sur le document PERSISTÉ de la page (`actualPage.page`), et non sur un champ d'état comme
 * `drillDownEnabled` juste en dessous : celui-ci est un basculement de session, celui-ci une
 * propriété enregistrée du dashboard.
 *
 * ⚠️ Le défaut est FAUX, et l'écriture `=== true` le garantit : un dashboard existant, dont le
 * document ne porte pas ce champ, garde exactement le comportement qu'il avait.
 */
export const selectDependentFilters = createSelector(
  [selectActualPage],
  page => page?.dependentFilters === true
)

// DRILL DOWN
export const selectDrillDownEnabled = createSelector(
  [selectPage],
  page => page.drillDownEnabled !== false
)
